export default __webpack_public_path__ + "static/media/head3.2b218d45.svg";